var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("AirExport.CompleteOperationRequirements"),
        width: "300px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "80px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_CompletionTime") } },
            [
              _c("el-date-picker", {
                ref: "finishedDate",
                staticStyle: { width: "200px" },
                attrs: { "value-format": "yyyy-MM-dd" },
                model: {
                  value: _vm.form.finishedDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "finishedDate", $$v)
                  },
                  expression: "form.finishedDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { type: "textarea", row: 5 },
                model: {
                  value: _vm.form.remarks,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remarks", $$v)
                  },
                  expression: "form.remarks"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okClickHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }